import './polyfills/contains';
import { breakpoints } from './breakpoint-constants';
import tippy from 'tippy.js';
var Tippy = /** @class */ (function () {
    function Tippy() {
        this.tippyClassName = 'js-tooltip';
        this.tippyHoverClassName = 'js-tooltip-hover';
        this.defaultDirection = 'bottom'; // top, bottom, left, right top-start, top-end, bottom-start, bottom-end
        this.verticalOffsetFlyout = '14'; // some vertical space between trigger element and tooltip
        this.verticalOffsetHover = '5'; // some vertical space between trigger element and tooltip
        this.horizontalOffset = '16'; // this is needed for non centered alignments, because the arrow should not be at the edge of the container.
        this.trigger = 'click'; // click, mouseenter focus, manual
        this.isFlyoutClassName = 'is-flyout';
        this.arrowListClassName = 'c-arrow-list';
        this.toggleOverflowClassName = 'u-overflow-hidden';
        this.flyoutScrollClassName = 'js-flyout-scroll';
        this.resizeTimeout = 0;
        this.createTippyFromNodeList(this.getNodeListFromDom('.' + this.tippyClassName + ', .' + this.tippyHoverClassName));
    }
    Tippy.getInstance = function () {
        if (!Tippy.instance) {
            Tippy.instance = new Tippy();
        }
        return Tippy.instance;
    };
    Tippy.prototype.createTippyFromNodeList = function (tippyDomElements) {
        var me = this;
        for (var i = 0; i < tippyDomElements.length; i++) {
            var tippyDomElement = tippyDomElements[i];
            if (!this.isInitialized(tippyDomElement)) {
                if (tippyDomElement.classList.contains(this.tippyClassName)) {
                    this.createFlyoutTippyObjects(me, tippyDomElement);
                    this.setOptionsForFlyoutTippy(tippyDomElement);
                }
                else if (tippyDomElement.classList.contains(this.tippyHoverClassName)) {
                    this.createHoverTippyObjects(tippyDomElement);
                    this.setOptionsForHoverTippy(tippyDomElement);
                }
            }
        }
    };
    Tippy.prototype.getNodeListFromDom = function (selectors) {
        return document.querySelectorAll(selectors);
    };
    Tippy.prototype.createFlyoutTippyObjects = function (me, tippyDomElement) {
        if (tippyDomElement && tippyDomElement.nextElementSibling) {
            var tippyContentContainer_1 = tippyDomElement.nextElementSibling;
            // @ts-ignore
            var instance_1 = tippy(tippyDomElement, {
                onShown: function (instance) {
                    me.bindFlyoutButtons(tippyContentContainer_1, instance);
                    instance.popper.classList.add(me.isFlyoutClassName);
                },
                onHide: function () {
                    me.toggleArrowListOverflow(tippyDomElement);
                },
                onShow: function (instance) {
                    var abortController = new AbortController();
                    me.toggleArrowListOverflow(tippyDomElement);
                    tippyContentContainer_1.addEventListener('focusout', function (event) {
                        if (tippyContentContainer_1.contains(event.relatedTarget))
                            return;
                        instance.hide();
                        abortController.abort();
                    }, { signal: abortController.signal });
                    instance.popper.addEventListener("keydown", function (event) {
                        if (event.code === "Space") {
                            event.preventDefault();
                            abortController.abort();
                            instance.hide();
                        }
                    }, { signal: abortController.signal });
                },
                html: tippyContentContainer_1,
                trigger: 'click',
                theme: 'flyout',
                offset: '0,' + this.verticalOffsetFlyout,
                animateFill: false,
                appendTo: document.getElementById(tippyDomElement.getAttribute("flyout-target-id")) || document.body,
                duration: 0,
                arrow: true,
                arrowType: 'sharp',
                flipDuration: 0,
                interactive: true,
                popperOptions: {
                    positionFixed: true,
                    modifiers: {
                        preventOverflow: {
                            boundariesElement: 'window'
                        }
                    }
                }
            });
            tippyDomElement.addEventListener("keydown", function (event) {
                if (event.code === "Space") {
                    event.preventDefault();
                    instance_1.tooltips[0].show();
                }
            });
        }
    };
    Tippy.prototype.createHoverTippyObjects = function (tippyDomElement) {
        var title = tippyDomElement.getAttribute('title');
        if (title) {
            // @ts-ignore
            tippy(tippyDomElement, {
                content: title,
                theme: 'primary',
                offset: '0,' + this.verticalOffsetHover,
                arrow: true,
                popperOptions: {
                    positionFixed: true,
                    modifiers: {
                        preventOverflow: {
                            boundariesElement: 'window'
                        }
                    }
                }
            });
        }
    };
    // bind close, reset and apply buttons
    Tippy.prototype.bindFlyoutButtons = function (content, tippyInstance) {
        this.bindFlyoutCloseBtn(content, tippyInstance);
        this.bindFlyoutResetBtn(content, tippyInstance);
    };
    Tippy.prototype.bindFlyoutCloseBtn = function (content, tippyInstance) {
        var closeBtns = content.querySelectorAll('.js-flyout-close');
        if (closeBtns) {
            for (var i = 0; i < closeBtns.length; i++) {
                closeBtns[i].addEventListener("click", function (e) {
                    e.preventDefault();
                    tippyInstance.hide();
                });
            }
        }
    };
    Tippy.prototype.bindFlyoutResetBtn = function (content, tippyInstance) {
        var _this = this;
        var resetBtn = content.querySelector('.js-flyout-reset');
        if (resetBtn) {
            resetBtn.addEventListener("click", function (e) {
                e.preventDefault();
                var checkboxes = content.querySelectorAll('input[type="checkbox"]');
                _this.resetCheckboxes(checkboxes);
            });
        }
    };
    Tippy.prototype.onResize = function (tippyInstance) {
        var _this = this;
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.setClickToClose(tippyInstance, breakpoints().breakpoints.tablet_up);
        }, 300);
    };
    Tippy.prototype.hideTippy = function (tippyInstance) {
        Array.from(document.querySelectorAll('.tippy-popper')).forEach(function (popper) {
            tippyInstance.hide();
        });
    };
    Tippy.prototype.isInitialized = function (tippyDomElement) {
        return !!tippyDomElement._tippy;
    };
    Tippy.prototype.resetCheckboxes = function (checkboxes) {
        var checkbox;
        for (var i = 0; i < checkboxes.length; i++) {
            checkbox = checkboxes[i];
            checkbox.checked = false;
            // trigger change event
            var event = document.createEvent("HTMLEvents");
            event.initEvent('change', false, true);
            checkbox.dispatchEvent(event);
        }
    };
    // enable or disable clicking outside the tooltip to close it
    Tippy.prototype.setClickToClose = function (tippyInstance, hideOnClick) {
        tippyInstance.options.hideOnClick = hideOnClick;
    };
    // set placement dynamically via data-tooltip-direction in html dom element.
    Tippy.prototype.setPlacement = function (tippyDomElement, tippyInstance) {
        tippyInstance.options.placement = tippyDomElement.getAttribute('data-tooltip-direction') || this.defaultDirection;
    };
    // set offset values. Horizontal alignment is in centered directions 0, otherwise positive or negative.
    Tippy.prototype.setOffset = function (tippyInstance) {
        var offset = ('0,' + this.verticalOffsetFlyout);
        if (tippyInstance.options.placement.indexOf('start') > -1) {
            offset = ('-' + this.horizontalOffset + ',' + this.verticalOffsetFlyout);
        }
        if (tippyInstance.options.placement.indexOf('end') > -1) {
            offset = (this.horizontalOffset + ',' + this.verticalOffsetFlyout);
        }
        tippyInstance.options.offset = offset;
    };
    Tippy.prototype.setOptionsForFlyoutTippy = function (tippyDomElement) {
        var _this = this;
        var tippyInstance = tippyDomElement._tippy;
        if (tippyInstance) {
            this.setPlacement(tippyDomElement, tippyInstance);
            this.setOffset(tippyInstance);
            this.setClickToClose(tippyInstance, breakpoints().breakpoints.tablet_up);
            window.addEventListener('resize', function () {
                _this.onResize(tippyInstance);
            });
            window.addEventListener('scroll', function () {
                if (breakpoints().breakpoints.tablet_up) {
                    _this.hideTippy(tippyInstance);
                }
            });
        }
    };
    Tippy.prototype.setOptionsForHoverTippy = function (tippyDomElement) {
        var tippyInstance = tippyDomElement._tippy;
        if (tippyInstance) {
            this.setPlacement(tippyDomElement, tippyInstance);
        }
    };
    // faceted breadcrumb toggle overflow on close/open tooltip for correct position calculation
    Tippy.prototype.toggleArrowListOverflow = function (tippyDomElement) {
        var arrowList = tippyDomElement.closest('.' + this.arrowListClassName);
        if (arrowList) {
            arrowList.classList.toggle(this.toggleOverflowClassName);
        }
    };
    return Tippy;
}());
export default Tippy;
